/**
 * Делит массив элементов на два подмассива
 */
export const splitIntoTwoColumns = <T>(items: T[]) => {
  const columnOne = items.slice(0, items.length / 2);
  const columnTwo = items.slice(items.length / 2, items.length);

  return [columnOne, columnTwo];
};
